import dynamic from 'next/dynamic';
import React, { FC } from 'react';

import type { Props } from './CompanyIntercom.Lazy';

const LazyCompanyIntercom = dynamic(() => import('./CompanyIntercom.Lazy'), {
    ssr: false,
});

const CompanyIntercom: FC<Props> = (props) => <LazyCompanyIntercom {...props} />;

export { CompanyIntercom };
